import React, { useCallback, useMemo } from "react"
import { usersController } from "../../api/controllers/users"
import useAsyncState from "../../hooks/useAsyncState"
import { GET_USERS_BY_PROJECT_FAILED_MESSAGE } from "../../store/users/constants"
import { useAppSelector } from "../../store/hooks"
import { selectCurrentProjectId } from "../../store/projects/selectors"
import ErrorMessage from "../ErrorMessage/ErrorMessage"
import ArticleUserViewCard from "../ArticleUserViewCard/ArticleUserViewCard"
import Async from "../Async/Async"
import ArticleUserCardsLoader from "./ArticleUserCardsLoader"
import { ArticleUserView } from "../../models/articleUserViews"
import { viewsToMap } from "../../utility/knowledgeBase/articleUserViews"
import styles from "./ArticleUserViewCards.module.scss"

interface Props {
    views: ArticleUserView[]
}

const ArticleUserViewCards: React.FC<Props> = props => {
    const { views } = props
    const projectId = useAppSelector(selectCurrentProjectId)
    const logins = useMemo(() => views.map(v => v.Login), [views])
    const viewsMap = useMemo(() => viewsToMap(views), [views])

    const loadUsers = useCallback(
        () =>
            projectId
                ? usersController.getUsersByLogins(projectId, {
                      Logins: logins
                  })
                : Promise.resolve([]),
        [projectId, logins]
    )
    const { asyncState: usersState } = useAsyncState(loadUsers, GET_USERS_BY_PROJECT_FAILED_MESSAGE)

    return (
        <Async
            dataState={usersState}
            processView={<ArticleUserCardsLoader />}
            errorView={({ message }) => <ErrorMessage text={message} />}
        >
            {({ data: users }) => {
                return (
                    <div className={styles.cardsList}>
                        {users.map((user, index) => (
                            <ArticleUserViewCard key={index} user={user} view={viewsMap[user.Login]} />
                        ))}
                    </div>
                )
            }}
        </Async>
    )
}

export default ArticleUserViewCards
